import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';
import { EncodeHtmlSymbolsPipe } from '@sb-tools/typescript/pipes/encode-html-symbols.pipe';
import { UserGroupDTO } from '@sb-tools/typescript/models/dto/user-group.dto';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { MentionedUser } from '../../../core/models/mentioned-user.model';
import { FacebookMentionUserModel } from '../../../core/models/facebook-mention-user-model.model';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { InlineImagePreviewDirective } from '../../../../sb-modules/Frontend-Document-Viewer-Module/directives/inline-image-preview.directive';
import { InlineImageLimitWidthDirective } from '../../directives/inline-image-limit-width.directive';
import { ReplaceEmojisPipe } from '../../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { PrepareMessagePipe } from '../../../../sb-tools/typescript/pipes/ticket/prepare-message.pipe';

@Component({
    selector: 'app-highlight-mention',
    templateUrl: './highlight-mention.component.html',
    styleUrls: ['./highlight-mention.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InlineImagePreviewDirective, InlineImageLimitWidthDirective, ReplaceEmojisPipe, PrepareMessagePipe],
})
export class HighlightMentionComponent implements OnChanges {
    @Input() isHtml = false;
    @Input() mentionedGroups: UserGroupDTO[] = [];
    @Input() mentionedUsers: MentionedUser[] | FacebookMentionUserModel[] | BaseUserWithRole[] | any = [];
    @Input() message: string;

    commentMessage: MessageDTO;
    updateStamp: number;

    constructor(
        private commonDataService: CommonDataService,
        private encodeHtmlSymbolsPipe: EncodeHtmlSymbolsPipe,
        private elRef: ElementRef,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        let newCommentText = this.message;
        const currentUserId = this.commonDataService.user.id;
        const currentUserClass: string = 'mention-user-current';

        if (!this.isHtml) {
            if (this.mentionedUsers && Array.isArray(this.mentionedUsers)) {
                this.mentionedUsers.forEach((mentionedUser) => {
                    const mentionedUserRegex = new RegExp('@' + mentionedUser.email.replace('+', '\\+'), 'g');
                    const mentionedUserNewRegex = new RegExp('{User:' + mentionedUser.id + '}', 'g');

                    const currentUserClassStr: string = currentUserId === mentionedUser.id ? currentUserClass : '';
                    const encodedName = this.encodeHtmlSymbolsPipe.transform(mentionedUser.name || mentionedUser.email);
                    const linkToUserInfo = `<span class="user-info-link mention-user mention ${currentUserClassStr}" userId="${mentionedUser.id}">@${encodedName}</span>`;

                    newCommentText = newCommentText.replace(mentionedUserRegex, linkToUserInfo);
                    newCommentText = newCommentText.replace(mentionedUserNewRegex, linkToUserInfo);
                });
            }

            if (this.mentionedGroups && Array.isArray(this.mentionedGroups)) {
                this.mentionedGroups.forEach((mentionedGroup) => {
                    const mentionedGroupRegex = new RegExp('{Group:' + mentionedGroup.id + '}', 'g');

                    const linkToGroupInfo =
                        '<span class="mention mention-group" data-mention-id="' +
                        mentionedGroup.id +
                        '">@' +
                        this.encodeHtmlSymbolsPipe.transform(mentionedGroup.name) +
                        '</span>';

                    newCommentText = newCommentText.replace(mentionedGroupRegex, linkToGroupInfo);
                });
            }
        }
        this.commentMessage = new MessageDTO(newCommentText, '');

        if (this.isHtml) {
            setTimeout(() => {
                this.elRef.nativeElement.querySelectorAll('.mention.mention-user').forEach((item) => {
                    const userId = item.attributes['userid']?.nodeValue;
                    if (currentUserId === userId) {
                        item.classList.add(currentUserClass);
                    }
                });

                const mentionedUsers = this.elRef.nativeElement.querySelectorAll(
                    '.mention:not(.mention-group):not(.mention-user)',
                );

                mentionedUsers.forEach((mentionElement) => {
                    const userId = mentionElement.attributes['data-id']?.nodeValue;
                    const user = this.mentionedUsers.find((element) => {
                        return element.id === userId;
                    });

                    const currentUserClassStr: string = currentUserId === userId ? currentUserClass : '';
                    const encodedName = this.encodeHtmlSymbolsPipe.transform(user.name || user.email);
                    mentionElement.innerHTML = `<span class="user-info-link mention-user mention ${currentUserClassStr}" userId="${userId}">@${encodedName}</span>`;
                });
            }, 0);

            if (changes.message && !changes.message.firstChange) {
                this.updateStamp = new Date().getTime();
            }
        }
    }
}
